<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>
      <CImage :src="sygnetLogo" alt="Logo" class="sidebar-brand-narrow" :height="35"/>
      <CImage :src="footerLogo" alt="Small Logo" class="sidebar-brand-full" size="sm" :height="30"/>
    </CSidebarBrand>
    <AppSidebarNav />
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import footerLogo from '@/assets/logo/footer-logo.png' 
import sygnetLogo from '@/assets/logo/gbf-logo.png'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  data(){
    return {
      footerLogo,
      sygnetLogo
    }
  },  
  setup() {
    const store = useStore()
    return {
      logoNegative: footerLogo,
      sygnet: sygnetLogo,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
